import './App.css';
import { Main } from './pages';
import { Layout } from './components';
import {
	createBrowserRouter,
	RouterProvider
} from "react-router-dom";

const router = createBrowserRouter([
	{
		path: "/",
		element: <Main />,
	}
]);

function App() {
  return (
    <div className="App">
      <Layout>
        <RouterProvider router={router} />
      </Layout>
    </div>
  );
}

export default App;
